export default __webpack_public_path__ + "static/media/future-of-work.5c0794a6.png";